import React from 'react';

import "./Loader.css";
import peacockFeather from "../images/loader.gif";



// Main Loader Component
const Loader = () => {
  return (
    <div className="loading-spinner">
        <div className="spinner">
            <img 
                src={peacockFeather} 
                alt="Peacock Feather" 
                className="peacock-feather-icon" 
            />
        </div>
    </div>
);
};


export default Loader;
